import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, userApiClient } from '@/setup/api'

export type ICityBrand = ApiResponseBody<'get', '/web/cities/{citySlug}/brands'>['data'][number]

export const getCityBrandsQueryOptions = (citySlug: string, locale: string) =>
    userApiClient.queryOptions('get', '/web/cities/{citySlug}/brands', {
        params: { path: { citySlug } },
        headers: { 'accept-language': locale },
    })

export function useGetCityBrandsQuery(citySlug: string) {
    return useQuery(getCityBrandsQueryOptions(citySlug, useLocale()))
}

export const findBrandBySlug = (
    brands: ICityBrand[] | undefined,
    brandSlug: string | null | undefined
) => (brandSlug ? brands?.find((brand) => brand.slug === brandSlug) : undefined)
